import { render, staticRenderFns } from "./addChecklistPageDialog.vue?vue&type=template&id=6d891ff2&lang=pug&"
import script from "./addChecklistPageDialog.vue?vue&type=script&lang=js&"
export * from "./addChecklistPageDialog.vue?vue&type=script&lang=js&"
import style0 from "./addChecklistPageDialog.vue?vue&type=style&index=0&id=6d891ff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports